var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Header
 */
var JOSEHeader = /*#__PURE__*/function () {
  "use strict";

  function JOSEHeader() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        typ = _ref.typ,
        cty = _ref.cty,
        alg = _ref.alg,
        jku = _ref.jku,
        kid = _ref.kid,
        x5u = _ref.x5u,
        x5c = _ref.x5c,
        x5t = _ref.x5t,
        crit = _ref.crit,
        enc = _ref.enc,
        zip = _ref.zip;

    _classCallCheck(this, JOSEHeader);

    this.typ = typ;
    this.cty = cty;
    this.alg = alg;
    this.jku = jku;
    this.kid = kid;
    this.x5u = x5u;
    this.x5c = x5c;
    this.x5t = x5t;
    this.crit = crit;
    this.enc = enc;
    this.zip = zip;
  }
  /**
   * isJWS
   */


  _createClass(JOSEHeader, [{
    key: "isJWS",
    value: function isJWS() {}
    /**
     * isJWE
     */

  }, {
    key: "isJWE",
    value: function isJWE() {}
  }]);

  return JOSEHeader;
}();
/**
 * Export
 */


module.exports = JOSEHeader;